import React from 'react';
import { CTAButton } from './CTAButton';
const PAINS = [{
  emoji: '😓',
  text: 'Llega un niño con Clase II y no sabes si el origen es funcional, dental o esquelético.'
}, {
  emoji: '😰',
  text: 'Cambias entre varios aparatos porque ninguno parece resolver el problema por completo.'
}, {
  emoji: '🤔',
  text: 'Sientes que conoces los aparatos… pero no tienes un método claro para decidir cuándo utilizar cada uno.'
}, {
  emoji: '⏳',
  text: 'Cada caso nuevo te obliga a volver a revisar apuntes, libros o pedir una segunda opinión.'
}, {
  emoji: '💬',
  text: 'Te cuesta explicar con seguridad a los padres por qué elegiste un aparato y no otro.'
}, {
  emoji: '📈',
  text: 'Quieres dejar de depender de la experiencia acumulada y comenzar a tomar decisiones siguiendo un proceso clínico claro.'
}];
export function PainPoints() {
  return <section className="w-full bg-cream px-5 py-14 sm:px-6 sm:py-20" data-id="element-202" data-mp="3ncxqjxllttli">
      <div className="mx-auto w-full max-w-3xl" data-id="element-203" data-mp="1z0f0oy5hpc7y">
        <h2 className="text-center font-display text-[28px] font-extrabold leading-tight text-ofm-900 sm:text-4xl" data-id="element-204" data-mp="1yz3wwyc1o4gu">
          Si alguna vez te pasó esto…
        </h2>
        <p className="mt-3 text-center text-[15px] font-semibold text-ofm-700 sm:text-lg" data-id="element-205" data-mp="27ticz34efj10">
          …este sistema fue creado para ti.
        </p>

        <ul className="mt-8 grid gap-3.5 sm:grid-cols-2" data-id="element-206" data-mp="23s6qh6gtndx1">
          {PAINS.map(pain => <li key={pain.text} className="flex gap-3 rounded-2xl border border-ofm-100 bg-white p-4 shadow-sm" data-id="element-207" data-mp="1g22rjcekw2cd">
              <span className="text-xl leading-none" aria-hidden="true" data-id="element-208" data-mp="1p30mz6ayb1jc">
                {pain.emoji}
              </span>
              <span className="text-[14px] leading-snug text-ofm-900/75" data-id="element-209" data-mp="1k2mn4bji6xwe">
                {pain.text}
              </span>
            </li>)}
        </ul>

        <CTAButton className="mt-9" label="🦷 QUIERO DEJAR DE IMPROVISAR" subline="Descarga inmediata · Garantía de 7 días" data-id="element-210" data-mp="2vitc6g63p5d1" />
      </div>
    </section>;
}